import { Truncate } from '@effectivastudio/lit-components/components/truncate/element.js';
import { html } from 'lit';

Truncate.prototype.renderTrigger = function renderTrigger() {
  return html`
    <button class="bu-btn btn-link">
      <span>${this.t('more')}</span>
      <bu-icon name="chevron-down"></bu-icon>
    </button>
  `;
};
